import * as angular from 'angular';
import { config } from 'angular/utils/config';
import { migratedRegularFcfsProcess } from 'angular/utils/migrated-regular-fcfs-process';

(function () {
    'use strict';

    angular.module('app').controller('FcfsBookingCtrl', FcfsBookingCtrl);

    function FcfsBookingCtrl(
        $window,
        $http,
        $scope,
        $log,
        $route,
        $routeParams,
        fcfsBookingService,
        Fcfs,
        ShipperUser,
        authService,
        activitiesService
    ) {
        if (migratedRegularFcfsProcess.isActive) {
            migratedRegularFcfsProcess.goToNewDesign();
            return;
        }

        var vm = this;
        var SUCCESSFUL = 'successful';
        var BOOKING_ERROR = 'error';

        vm.ui = {};
        vm.stages = fcfsBookingService.stages;
        vm.pages = fcfsBookingService.pages;
        vm.service = {
            CHARGE_TYPES: fcfsBookingService.CHARGE_TYPES,
            selectedAlt: null,
            consolidateCharges: consolidateCharges,
            migratedRegularFcfsProcess: migratedRegularFcfsProcess
        };
        vm.onNext = onNext;
        vm.restart = restart;
        vm.finished = finished;
        vm.startNewOne = startNewOne;
        vm.onError = onError;
        vm.STORAGE_PREFIX = fcfsBookingService.STORAGE_PREFIX;
        vm.REST_CONTEXT = config.monolithApi;
        vm.stageConfig = config;
        vm.generalError = '';

        vm.data = fcfsBookingService.getAllStages();

        $scope.$watch(
            function () {
                return vm.service.selectedAlt;
            },
            function () {
                fcfsBookingService.selectedAlternative = vm.service.selectedAlt;
            }
        );

        if ($routeParams.stage === SUCCESSFUL) {
            vm.ui.successfulBooking = true;
            vm.ui.errorPage = false;
            vm.success = fcfsBookingService.getSuccess();
            vm.success.activities = activitiesService.map(
                vm.success.activities
            ).activities; //map so icon is shown
            vm.ui.showsuccess = true;
            setTimeout(function () {
                $scope.$apply(function () {
                    vm.ui.showsuccess = false;
                });
            }, 5000);
        } else if ($routeParams.stage === BOOKING_ERROR) {
            vm.ui.errorPage = true;
            vm.ui.successfulBooking = false;
            vm.generalError = fcfsBookingService.bookingError;
        }

        function consolidateCharges(part) {
            var types = fcfsBookingService.CHARGE_TYPES;
            var consolidated = [];
            for (var y = 0; y < types.length; y++) {
                var charge0 = getCharge(part.tsoPart0, types[y]);
                var charge1 = getCharge(part.tsoPart1, types[y]);
                if (
                    !angular.isUndefined(charge0) ||
                    !angular.isUndefined(charge1)
                ) {
                    consolidated.push({
                        type: types[y],
                        0: charge0,
                        1: charge1
                    });
                }
            }
            return consolidated;
        }

        function getCharge(offer, chargeType) {
            if (!angular.isUndefined(offer)) {
                for (var i = 0; i < offer.charges.length; i++) {
                    if (chargeType === offer.charges[i].type) {
                        return offer.charges[i].priceDto;
                    }
                }
            }
        }

        function onNext() {
            vm.data = fcfsBookingService.getAllStages();
        }

        function restart() {
            fcfsBookingService.reset();
            $scope.$broadcast(fcfsBookingService.BROADCAST.WIZARD_RESTART);
        }

        function finished() {
            onNext();

            // returning a promise
            return Fcfs.orderCapacity(mappedData(), function (res) {
                vm.success = {};
                vm.success.response = res;
                vm.success.response.dealId = res.legalContractPositionId0;
                vm.success.activities = [];

                for (var i = 0; i < vm.success.response.positions.length; i++) {
                    var activityItem = {
                        category: 'FCFS',
                        uiFrame: {
                            id: res.positions[i].dealId
                        },
                        state: res.state,
                        bidId: res.id,
                        dealId: res.positions[i].dealId,
                        networkPoint: res.networkPoint,
                        capacityCategory0: !!res.positions[i].capacityCategory0
                            ? res.positions[i].capacityCategory0
                            : vm.data.stageTwo.capacityCategory0,
                        capacityCategory1: !!res.positions[i].capacityCategory1
                            ? res.positions[i].capacityCategory1
                            : vm.data.stageTwo.capacityCategory1,
                        allocation: {
                            price: getRegulatedTariff(
                                res.positions[i].charges0
                            ),
                            quantity: res.positions[i].quantity
                        },
                        runtime: res.positions[i].runtime,
                        createdAt: new Date()
                    };
                    vm.success.activities.push(activityItem);
                }

                function getRegulatedTariff(charges) {
                    for (var i = 0; i < charges.length; i++) {
                        if (charges[i].type === 'REGULATED') {
                            return charges[i].priceDto;
                        }
                    }
                }

                ShipperUser.loggedInShipperUser({}, function (res) {
                    if ($.isEmptyObject(res.toJSON())) {
                        authService.logOut();
                    }
                    for (var i = 0; i < vm.success.activities.length; i++) {
                        vm.success.activities[i].createdBy =
                            res.firstName + res.lastName;
                    }
                });

                fcfsBookingService.setSuccess(vm.success);
                $route.updateParams({ stage: SUCCESSFUL });
            }).$promise;
        }

        function onError() {
            $route.updateParams({ stage: BOOKING_ERROR });
        }

        function startNewOne() {
            restart();
            $route.updateParams({ stage: null });
        }

        function mappedData() {
            var positions;
            var alternative;

            if (vm.service.selectedAlt !== null) {
                // checkResponse.offer is not necessarily available here, so only use data from stageTwo.checked
                vm.service.selectedAlt.selected = true;

                alternative = angular.copy(vm.service.selectedAlt);
                delete alternative.selected;

                positions = [];
                angular.forEach(vm.service.selectedAlt.parts, function (part) {
                    var position: any = {
                        runtime: part.contract.interval,
                        capacityCategory0: part.contract.capacityCategory0,
                        capacityCategory1: part.contract.capacityCategory1,
                        networkPoint: vm.data.stageTwo.checked.networkPoint,
                        quantity: part.quantity,
                        charges0: part.tsoPart0.charges,
                        offerId0: part.tsoPart0.offerId
                    };

                    if (!angular.isUndefined(part.tsoPart1)) {
                        position.charges1 = part.tsoPart1.charges;
                        position.offerId1 = part.tsoPart1.offerId;
                    }

                    positions.push(position);
                });
            } else {
                // checkResponse.offer is available here, so only use data from there
                alternative = {
                    parts: [vm.data.stageTwo.checkResponse.offer]
                };

                positions = [
                    {
                        runtime:
                            vm.data.stageTwo.checkResponse.offer.contract
                                .interval,
                        capacityCategory0:
                            vm.data.stageTwo.checkResponse.offer.contract
                                .capacityCategory0,
                        capacityCategory1:
                            vm.data.stageTwo.checkResponse.offer.contract
                                .capacityCategory1,
                        networkPoint:
                            vm.data.stageTwo.checkResponse.offer.contract
                                .networkPoint,
                        quantity: vm.data.stageTwo.checkResponse.offer.quantity,
                        charges0:
                            vm.data.stageTwo.checkResponse.offer.tsoPart0
                                .charges,
                        offerId0:
                            vm.data.stageTwo.checkResponse.offer.tsoPart0
                                .offerId
                    }
                ];
                if (
                    !angular.isUndefined(
                        vm.data.stageTwo.checkResponse.offer.tsoPart1
                    )
                ) {
                    positions.charges1 =
                        vm.data.stageTwo.checkResponse.offer.tsoPart1.charges;
                    positions.offerId1 =
                        vm.data.stageTwo.checkResponse.offer.tsoPart1.offerId;
                }
            }
            return {
                correlationId: vm.data.stageTwo.checkResponse.correlationId,
                order: {
                    networkPoint: vm.data.stageTwo.checked.networkPoint,
                    positions: positions,
                    state:
                        vm.data.stageTwo.checkResponse.responseType ===
                        'MANUALLY_PROCESSED'
                            ? 'WAITING'
                            : 'IN_COMMISSION',
                    label: vm.data.stageThree.bookingLabel,
                    upgrade0: vm.data.stageThree.upgradeRequested
                        ? vm.data.stageThree.upgrade0
                        : null,
                    upgrade1: vm.data.stageThree.upgradeRequested
                        ? vm.data.stageThree.upgrade1
                        : null,
                    balancingGroup0: vm.data.stageThree.balancingGroup0,
                    balancingGroup1: vm.data.stageThree.balancingGroup1,
                    portfolioCode0: vm.data.stageThree.portfolio0,
                    portfolioCode1: vm.data.stageThree.portfolio1
                },
                alternative: alternative
            };
        }
    }
})();
